// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".stage-area-stage-area-55iOzck4mwr{position:relative;background-color:var(--top-bar);flex-shrink:0;padding:32px}.stage-area-stage-area-55iOzck4mwr.stage-area-inModal-78TH885Gmwr{padding:20px}@media (min-width: 1300px){.stage-area-stage-area-55iOzck4mwr{padding:32px}.stage-area-stage-area-55iOzck4mwr.stage-area-inModal-78TH885Gmwr{padding:32px}}@media (min-width: 1500px){.stage-area-stage-area-55iOzck4mwr{padding:32px}.stage-area-stage-area-55iOzck4mwr.stage-area-inModal-78TH885Gmwr{padding:32px}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"stage-area": "stage-area-stage-area-55iOzck4mwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bottom-divider"] + "",
	"stageArea": "stage-area-stage-area-55iOzck4mwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bottom-divider"] + "",
	"inModal": "stage-area-inModal-78TH885Gmwr"
};
module.exports = exports;
